// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2b13f746","865":"9c10407e"}[chunkId] + ".chunk.js";
};